var map = {
	"./Aminart.jpeg": 915,
	"./Cyberwing.pk.jpg": 841,
	"./Echonotes.png": 242,
	"./Fitlog.png": 855,
	"./Flavusion.png": 499,
	"./IvorMedia.jpg": 922,
	"./Opentech.jpg": 382,
	"./Projectshub.png": 439,
	"./RomeRents (6).jpeg": 187,
	"./UrbanEdge.png": 847,
	"./activemen.png": 470,
	"./amneats-min.webp": 38,
	"./anchorslab.png": 9,
	"./bayaan.png": 566,
	"./drtank-min.webp": 247,
	"./ecomtimes.jpg": 42,
	"./foxapp-min.webp": 801,
	"./greenhands.png": 296,
	"./romewheels.png": 885,
	"./technthread.png": 106,
	"./todolist-min.webp": 141,
	"./tracalorie-min.webp": 249,
	"./wrapxen.png": 285,
	"./xoniclabs-min.webp": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;